
export function processIncommingMessage(data) {
  
    const jsonData = JSON.parse(data);
     
    switch (jsonData.type) {
        case 'NEWMESSAGE':
            return {type: 'NEWMESSAGE', data: jsonData.data}; 
            break;
        case 'DELETEDMESSAGE':
            return {type: 'DELETEDMESSAGE', uuid: jsonData.data.id}; 
            break;
        case 'UPDATEMESSAGE':
          
            return {type: 'UPDATEMESSAGE', data: jsonData.data}; 
         default: 
            return jsonData;       
     }

   
    return jsonData;
}  



// {"message":"sending a message to Blezourblec","sender_id":"64","conversation_id":"3","updated_at":"2024-03-30T13:02:13.000000Z","created_at":"2024-03-30T13:02:13.000000Z","id":18,"sender":{"id":64,"first_name":"blezour","last_name":"blec","email":"blezourblec@gmail.com","locationId":"kQ5yQFs3ryOYRvOuMJEz","is_client":0,"userID":"AdgUpVwyk9UOLRZNr6Fy","role":"admin","last_login_at":"2024-03-26 15:29:10","user_id":1,"created_at":"2023-11-13T14:09:58.000000Z","updated_at":"2024-03-26T14:29:10.000000Z","color":"#ffff","phone":"+237682325939","android":null,"ios":null},"attachments":[]}